Oskari.bundle_manager.registerDynamic('admin-announcements', function() {return import(/* webpackChunkName: "chunk_admin-announcements" */ 'oskari-loader!oskari-frontend/packages/admin/bundle/admin-announcements/bundle.js');});
